/**
 * Scroll Row Module
 *
 * Horizontal scroll containers with arrow buttons and drag-to-scroll.
 * Used by shop product carousels, featured products, and recommendations.
 * Safe to call multiple times — skips already-initialized rows.
 */

export function init() {
  document.querySelectorAll("[data-scroll-row]:not([data-scroll-init])").forEach((row) => {
    row.dataset.scrollInit = "true";
    const track = row.querySelector("[data-scroll-track]");
    const prevBtn = row.querySelector("[data-scroll-prev]");
    const nextBtn = row.querySelector("[data-scroll-next]");
    if (!track) {
      return;
    }

    const scrollAmount = 280;

    function updateArrows() {
      if (prevBtn) {
        prevBtn.disabled = track.scrollLeft <= 0;
      }
      if (nextBtn) {
        nextBtn.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener("click", () => {
        track.scrollBy({ left: -scrollAmount, behavior: "smooth" });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener("click", () => {
        track.scrollBy({ left: scrollAmount, behavior: "smooth" });
      });
    }

    // Debounce scroll via requestAnimationFrame
    let scrollRafId = 0;
    track.addEventListener("scroll", () => {
      if (!scrollRafId) {
        scrollRafId = requestAnimationFrame(() => {
          updateArrows();
          scrollRafId = 0;
        });
      }
    }, { passive: true });
    updateArrows();

    // Drag to scroll — listeners scoped to this row's lifecycle
    let isDragging = false;
    let startX = 0;
    let scrollStart = 0;
    let hasMoved = false;

    track.addEventListener("mousedown", (e) => {
      isDragging = true;
      hasMoved = false;
      startX = e.pageX;
      scrollStart = track.scrollLeft;
      track.classList.add("is-dragging");
      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", onMouseUp);
    });

    function onMouseMove(e) {
      if (!isDragging) {
        return;
      }
      const dx = e.pageX - startX;
      if (Math.abs(dx) > 3) {
        hasMoved = true;
      }
      track.scrollLeft = scrollStart - dx;
    }

    function onMouseUp() {
      if (!isDragging) {
        return;
      }
      isDragging = false;
      track.classList.remove("is-dragging");
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    }

    // Prevent click on links after drag
    track.addEventListener("click", (e) => {
      if (hasMoved) {
        e.preventDefault();
      }
    }, true);
  });
}
